import { useState, useEffect } from "react";
import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Button, Autocomplete } from "@mui/material";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useProductStore } from "../../../hooks/useProductStore";
import '../../../assets/styles/facturacionv3-app.css'

type Values = {
    id: number,
    price: number,
    cost: number,
    quantity: number,
    subtotal: number,
    idlist: number,
    idproduct: number,
    status: string,
}

const states = [
    {name: 'Activo', value: 1},
    {name: 'Desactivo', value: 2},
]

export const DetailListModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, listSelected, detailSelected, liststore, clearState } = props;

    const { action, createStore, editStore } = useStoreStore();
    const { getProductsByCompany } = useProductStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [productselected, setproductSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: detailSelected ? detailSelected.id :'',
        price: detailSelected ? detailSelected.price :'',
        cost: detailSelected ? detailSelected.cost :'',
        quantity: detailSelected ? detailSelected.quantity : 1,
        subtotal: detailSelected ? detailSelected.subtotal : 0,
        idlist: detailSelected ? detailSelected.idlist :'',
        idproduct: detailSelected ? detailSelected.idproduct :'',
        status: detailSelected ? detailSelected.status :'',
    });

    useEffect(() => {
        getProductsByCompanyApi()
    },[])

    const getProductsByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getProductsByCompany({search:search});

            const newData:any = [];
            response && (response).length > 0 && (response).map((item)=>{
                newData.push({
                    id: item.id,
                    code: item.code,
                    barcode: item.barcode,
                    name: item.name,
                    description: item.description,
                    cointypesymbol: item.cointypesymbol,
                    cost: item.cost,
                    price: item.price,
                    offerprice: item.offerprice,
                    quantity: 0,
                    subtotal: 0,
                    idcompany: item.idcompany,
                })
            })
            setProducts(newData || []);
            setLoadingdata(false);
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.validity) errors.validity = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idcompanies = (values.idcompanies).map(company => company.id) || [];

        const formdata = {
            ...values,
            type_person: '0',
            age: (values.age).toString(),
            idcompanies: JSON.stringify(idcompanies),
            password_confirmation: values.password,
        }

        if(detailSelected){
            const response:any = await editStore(detailSelected.id, formdata);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(formdata);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <>
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh'}}}>
            <ModalHeader
                text={'Agregar producto'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>

                                        <Grid item xs={12} md={8}>
                                            <FormLabel>Producto:</FormLabel>
                                            <Autocomplete
                                                id="idproduct"
                                                size="small"
                                                value={!!productselected ? productselected : null}
                                                options={products || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idproduct && touched.idproduct ? true : false}
                                                        helperText={errors.idproduct && touched.idproduct ? errors.idproduct : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setproductSelected(newValue)
                                                    setFieldValue('idproduct', newValue ? newValue.id : "");
                                                    setFieldValue('price', newValue ? newValue.price : "");
                                                    setFieldValue('cost', newValue ? newValue.cost : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Precio:</FormLabel>
                                            <TextField
                                                id="price"
                                                type="number" 
                                                name="price"
                                                fullWidth
                                                size="small"
                                                value={values.price}
                                                onChange={handleChange}
                                                error={errors.price && touched.price ? true : false}
                                                helperText={errors.price && touched.price ? errors.price : ''}
                                                inputProps={{ min: 0 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Costo:</FormLabel>
                                            <TextField
                                                id="cost"
                                                type="number" 
                                                name="cost"
                                                fullWidth
                                                size="small"
                                                value={values.cost}
                                                onChange={handleChange}
                                                error={errors.cost && touched.cost ? true : false}
                                                helperText={errors.cost && touched.cost ? errors.cost : ''}
                                                inputProps={{ min: 0 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Cantidad:</FormLabel>
                                            <TextField
                                                id="quantity"
                                                type="number" 
                                                name="quantity"
                                                fullWidth
                                                size="small"
                                                value={values.quantity}
                                                onChange={handleChange}
                                                error={errors.quantity && touched.quantity ? true : false}
                                                helperText={errors.quantity && touched.quantity ? errors.quantity : ''}
                                                inputProps={{ min: 1 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Subtotal:</FormLabel>
                                            <TextField
                                                id="subtotal"
                                                type="number" 
                                                name="subtotal"
                                                fullWidth
                                                size="small"
                                                value={values.subtotal}
                                                onChange={handleChange}
                                                error={errors.subtotal && touched.subtotal ? true : false}
                                                helperText={errors.subtotal && touched.subtotal ? errors.subtotal : ''}
                                                inputProps={{ min: 0 }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                    loadingConfirmText={loading}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
        </>
    )
}